import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextMono = () => {

return(
<div>
    
<Typography variant="h6" >
<br /><br /> 
 Monogenic and Polygenic obesity research more and more merges as the underlying biology is the same.
 Genes identified for monogenic obesity were discovered from early 90s on. Body Mass Index is commonly used as general phenotype for obesity. But BMI does not distinguish between lean and fat mass.
 <br /><br /> 
 We checked more than 3.000 genes which are associated with obesity so far.
 <br /><br /> 

 <Typography component="span" variant="h5" sx={{fontWeight: '600'}}>Obesity Associated Genes:</Typography>
<br /><br />

'NADK', 'TTC34' 'DNAJC11' 'CAMTA1' 'RERE' 'CASZ1' 'MASP2' 'SRM' 'MTOR'
 'NPPB' 'CELA2B' 'LINC01783' 'CROCC' 'ATP13A2' 'MICOS10' 'TEX46' 'KDM1A'
 'LUZP1' 'ZNF436' 'ADGRB2' 'A3GALT2' 'PHC2' 'CSMD2' 'HIVEP3' 'MAST2'
 'PIK3R3' 'TAL1' 'BEND5' 'AGBL4' 'ELAVL4' 'SSBP3' 'DAB1' 'PATJ' 'L1TD1'
 'LEPROT' 'LEPR' 'PDE4B' 'NEGR1' 'TNNI3K' 'AK5' 'MGC27382' 'ADGRL2'
 'TTLL7' 'EVI5' 'LINC01787' 'DPYD' 'PRMT6' 'PSMA5' 'INKA2' 'DDX20' 'KCND3'
 'NRAS' 'CSDE1' 'CTSS' 'PRUNE1' 'BNIPL' 'SEMA6C' 'DCST2' 'GON4L' 'U4'
 'SSR2' 'UBQLN4' 'MEX3A' 'MIR9-1HG' 'MEF2D' 'POU2F1' 'ANKRD45' 'RABGAP1L'
 'COP1' 'SEC16B' 'LINC01720' 'F13B' 'ZBTB41' 'NAV1' 'IPO9' 'LMOD1' 'ARL8A'
 'NUCKS1' 'SYT14' 'DNAH14' 'B3GALNT2' 'AKT3' 'SH3YL1' 'ALKAL2' 'TMEM18'
 'SNTG2' 'CENPO' 'ADCY3' 'DNAJC27-AS1' 'EFR3B' 'POMC' 'DNMT3A' 'KCNK3'
 'PPM1G' 'GCKR' 'PPP1CB' 'FEZ2' 'VIT' 'RNU6-939P' 'SLC8A1-AS1' 'MTA3'
 'CAMKMT' 'LINC01118' 'LINC01119' 'LHCGR' 'NRXN1' 'RTN4' 'LINC01122'
 'EHBP1' 'LINC01104' 'LONRF2' 'PANTR1' 'MRPS9-AS2' 'SH3RF3' 'PSD4'
 'NCKAP5' 'RAB3GAP1' 'LRP1B' 'TEX41' 'GALNT13' 'LINC01876' 'SLC4A10'
 'GRB14' 'COBLL1' 'SCN2A' 'STK39' 'DYNC1I2' 'METAP1D' 'OLA1' 'SCHLAP1'
 'RFTN2' 'BOLL' 'PLCL1' 'ICA1L' 'NBEAL1' 'CYP20A1' 'PARD3B' 'ZDBF2' 'CPS1'
 'VIL1' 'USP37' 'PLCD4' 'TTLL4' 'TUBA4B' 'PTPRN' 'SPHKAP' 'TRIP12' 'AGAP1'
 'ATG4B' 'LMCD1-AS1' 'THUMPD3' 'HRH1' 'PPARG' 'IQSEC1' 'ANKRD28'
 'SATB1-AS1' 'SGO1-AS1' 'RARB' 'ARPP21' 'ACVR2B' 'CCK' 'LIMD1' 'CSPG5'
 'SMARCC1' 'MAP4' 'CDC25A' 'SLC25A20' 'TRAIP' 'MON1A' 'SEMA3F' 'HEMK1'
 'DOCK3' 'TWF2' 'NEK4' 'ITIH1' 'ITIH3' 'ITIH4' 'RFT1' 'CACNA1D' 'FHIT'
 'PTPRG' 'FEZF2' 'CADPS' 'ADAMTS9-AS2' 'SAMMSON' 'ROBO2' 'ROBO1'
 'LINC00971' 'CADM2' 'HTR1F' 'EPHA3' 'HHLA2' 'MYH15' 'ADCY5' 'HACD2'
 'HEG1' 'CPNE4' 'RPL7P16' 'EPHB1' 'RPL31P23' 'STAG1' 'SLC35G2' 'NCK1'
 'MRAS' 'KRT18P35' 'GYG1' 'DHX36' 'GPR149' 'CCNL1' 'SLC7A14-AS1' 'EIF5A2'
 'SLC2A2' 'TNIK' 'SOX2-OT' 'ETV5' 'DGKG' 'UBXN7' 'LDB2' 'LCORL' 'SLIT2'
 'SEPSECS' 'ZCCHC4' 'ANAPC4' 'PCDH7' 'KLF3-AS1' 'KLF3' 'KCTD8' 'CWH43'
 'SPATA18' 'ART3' 'SCARB2' 'ABCG2' 'CCSER1' 'GRID2' 'SMARCAD1-DT' 'UNC5C'
 'ADH1B' 'PPP3CA' 'SLC39A8' 'SLC9B1' 'ALPK1' 'C4orf3' 'LINC02465' 'INPP4B'
 'HHIP' 'ANAPC10' 'LINC01019' 'CDH12' 'ZNF131' 'NIM1K' 'PDE4D' 'ZSWIM6'
 'MRPL49P1' 'ADAMTS6' 'MAST4' 'POC5' 'LINC02060' 'LINC00461' 'MEF2C'
 'PCSK1' 'CAST' 'CHD1-DT' 'FBXL17' 'PJA2' 'NREP-AS1' 'APC' 'CEP120'
 'LINC02240' 'HBEGF' 'LINC01470' 'GRIA1' 'MFAP3' 'EBF1' 'LINC03000'
 'TENM2' 'SLIT3' 'RANBP17' 'FGFR4' 'PRELID1' 'PKMP5' 'HIVEP1' 'PHACTR1'
 'E2F3' 'CDKAL1' 'CASC15' 'H1-4' 'ZSCAN31' 'PPP1R10' 'HLA-DRB9'
 'Metazoa_SRP' 'LINC00336' 'MLN' 'CYCSP55' 'ANKS1A' 'SCUBE3' 'FKBP5'
 'LINC00951' 'LRFN2' 'TREM2' 'VEGFA' 'SUPT3H' 'RCAN2' 'TFAP2B' 'RPS17P5'
 'PKHD1' 'LRRC1' 'MLIP' 'HCRTR2' 'GFRAL' 'DST' 'BEND6' 'EEF1B2P5' 'ADGRB3'
 'KCNQ5' 'NACAP7' 'ANKRD6' 'KLHL32' 'MMS22L' 'ASCC3' 'FOXO3' 'NKAIN2'
 'LINC02523' 'HEY2-AS1' 'L3MBTL3' 'ARG1' 'HIVEP2' 'RGS17' 'OPRM1'
 'SLC22A3' 'UNCX' 'MAD1L1' 'FBXL18' 'RAC1' 'DGKB' 'HOXA13' 'JAZF1' 'PDE1C'
 'POU6F2' 'ZMIZ2' 'DDC' 'AUTS2' 'GTF2I' 'RCC1L' 'POM121C' 'PMS2P3' 'HIP1'
 'DTX2P1' 'UPK3BP1' 'PMS2P11' 'GSAP' 'MAGI2' 'CALCR' 'GNGT1' 'ATP5MF'
 'ZKSCAN5' 'VGF' 'CNTNAP2' 'KCNH2' 'RPL10P19' 'TNKS' 'PINX1' 'XKR6' 'TDH'
 'DEFB136' 'SGCZ' 'TUSC3' 'SLC25A37' 'PURG' 'NRG1' 'FGFR1' 'CLVS1'
 'LINC01414' 'KCNB2' 'RMDN1' 'ESRP1' 'ZFPM2' 'TRPS1' 'LINC00536' 'EXT1'
 'PTPRD' 'ZDHHC21' 'FREM1' 'CCDC171' 'CTAGE12P' 'LINGO2' 'UBAP2' 'DCAF12'
 'PAX5' 'TRPM3' 'GNAQ' 'NTRK2' 'PHF2' 'ANKS6' 'NAMA' 'TEX10' 'GRIN3A'
 'LINC01505' 'FRRS1L' 'TTLL11' 'CRB2' 'NEK6' 'LMX1B' 'DNM1' 'MED27'
 'OLFM1' 'PNPLA7' 'EHMT1' 'RSU1' 'CACNB2' 'MALRD1' 'MIR1915HG' 'MLLT10'
 'DNAJC1' 'LINC00838' 'PRKG1' 'ANK3' 'JMJD1C' 'REEP3' 'ADK' 'DUSP13'
 'LRMDA' 'KCNMA1' 'SORBS1' 'ARHGAP19' 'CRTAC1' 'LOXL4' 'BTRC' 'ELOVL3'
 'GBF1' 'BORCS7' 'AS3MT' 'CNNM2' 'NT5C2' 'HSPA12A' 'RPL19P16' 'LINC02641'
 'CTBP2' 'JAKMIP3' 'PNPLA2' 'TSPAN4' 'CHID1' 'BRSK2' 'SLC22A18AS' 'FHIP1B'
 'STK33' 'TRIM66' 'BMAL1' 'NCR3LG1' 'KCNJ11' 'LGR4' 'LINC00678' 'BDNF-AS'
 'BDNF' 'METTL15' 'MPPED2' 'ELP4' 'RCN1' 'HSD17B12' 'ALKBH3' 'LINC02687'
 'MYBPC3' 'SLC39A13-AS1' 'NUP160' 'SLC22A11' 'SLC22A12' 'NRXN2' 'CFL1'
 'EFEMP2' 'FOSL1' 'PACS1' 'NPAS4' 'PPP6R3' 'IGHMBP2' 'LINC01488' 'LTO1'
 'GAB2' 'DLG2' 'CHORDC1' 'DISC1FP1' 'SMCO4' 'DYNC2H1' 'NCAM1' 'TTC12'
 'ZBTB16' 'CADM1' 'SIK3' 'PAFAH1B2' 'CEP164' 'HYOU1' 'VPS11' 'UBASH3B'
 'SNX19' 'NTM' 'OPCML' 'SPATA19' 'IGSF9B' 'WNK1' 'RAD52' 'CACNA1C'
 'EEF1A1P16' 'PLEKHA5' 'SOX5' 'PDZRN4' 'BCDIN3D' 'FAIM2' 'POU6F1' 'ESPL1'
 'IKZF4' 'ERBB3' 'PA2G4' 'ZC3H10' 'TAFA2' 'CPSF6' 'C1GALT1P1' 'YEATS4'
 'LINC02822' 'RMST' 'ANKS1B' 'C12orf42' 'ABTB3' 'MMAB' 'GLTP' 'GPN3'
 'TRAFD1' 'PTPN11' 'LINC01234' 'FBXO21' 'KSR2' 'CFAP251' 'BCL7A' 'MLXIP'
 'CLIP1' 'KNTC1' 'PITPNM2' 'ATP6V0A2' 'RFLNA' 'GOLGA3' 'CHFR' 'ZMYM2'
 'MTIF3' 'FLT3' 'HMGB1' 'N4BP2L1' 'LINC00598' 'DLEU1' 'LINC00558'
 'LINC00458' 'PCDH17' 'STARP1' 'SLAIN1' 'HS6ST3' 'STK24' 'ARHGEF7' 'TEX29'
 'PRKD1' 'AKAP6' 'MDGA2' 'PRKCH' 'SERTAD4BP' 'GALNT16' 'DCAF4' 'LINC02288'
 'NRXN3' 'RPS6KA5' 'TRIP11' 'BTBD7' 'UNC79' 'PRIMA1' 'BCL11B' 'MEG9'
 'TRAF3' 'CKB' 'KLC1' 'GABRB3' 'OTUD7A' 'DPH6' 'MGA' 'SEMA6D' 'LINC02490'
 'TCF12-DT' 'ADAM10' 'MYO1E' 'RORA' 'MEGF11' 'ZWILCH' 'IQCH' 'MAP2K5'
 'BBS4' 'ADPGK-AS1' 'HCN4' 'STOML1' 'PML' 'LINGO1' 'ANKRD34C-AS1'
 'ABHD17C' 'SLCO3A1' 'LINC00923' 'IGF1R' 'PGPEP1L' 'AXIN1' 'CLUAP1'
 'NLRC3' 'DNASE1' 'ADCY9' 'PPL' 'RBFOX1' 'BFAR' 'PDXDC1' 'SNRPEP3' 'PDILT'
 'CACNG3' 'SBK1' 'SULT1A1' 'RABEP2' 'CD19' 'TAOK2' 'TLCD3B' 'GDPD3'
 'BCL7C' 'STX1B' 'ZNF668' 'KAT8' 'ITGAX' 'TOX3' 'FTO' 'PRMT7' 'UTP4'
 'AARS1' 'COG4' 'VAC14' 'ZFHX3' 'CMIP' 'RTN4RL1' 'SMG6' 'TSR1' 'KIF1C'
 'DLG4' 'GLP2R' 'RAI1' 'LINC01992' 'MYO18A' 'SSH2' 'SLC6A4' 'ASIC2'
 'MYO19' 'HNF1B' 'KRTAP4-16' 'KRTAP4-11' 'KRT37' 'MAPT' 'KANSL1'
 'CDK5RAP3' 'SNX11' 'SKAP1' 'HOXB5' 'TTLL6' 'IGF2BP1' 'MSI2' 'C17orf58'
 'GALK1' 'TRIM47' 'TRIM65' 'LINC01977' 'NPTX1' 'RPL32P31' 'RPTOR' 'BAIAP2'
 'FASN' 'ARHGAP28' 'TMEM241' 'RMC1' 'NPC1' 'LINC01915' 'AQP4-AS1' 'ASXL3'
 'PIK3C3' 'LINC00907' 'SETBP1' 'ZBTB7C' 'DCC' 'TCF4' 'MC4R' 'BCL2'
 'LINC01541' 'KLF16' 'CSNK1G2' 'PIAS4' 'ZBTB7A' 'MAP2K2' 'DNASE2' 'KLF1'
 'JUND' 'PGPEP1' 'GDF15' 'CRTC1' 'ZNF536' 'KCTD15' 'POU2F2' 'TOMM40'
 'MARK4' 'GIPR' 'QPCTL' 'CCDC61' 'NPAS1' 'ZC3H4' 'SAE1' 'PPFIA3' 'SIGLEC9'
 'IGLON5' 'PTPRA' 'PLCB1' 'PLCB4' 'MACROD2' 'KIF16B' 'ZNF133' 'NKX2-4'
 'ACSS1' 'VSX1' 'ENTPD6' 'NANP' 'HCK' 'PIGPP3' 'EIF2S2' 'TP53INP2'
 'DLGAP4' 'CDH22' 'SALL4' 'LINC01524' 'TAF4' 'DIDO1' 'DNAJC5' 'TCEA2'
 'KCNJ6' 'BRWD1' 'DSCAM' 'BACE2' 'ADARB1' 'BCL2L13' 'BID' 'CACNG2'
 'TNRC6B' 'MRTFA' 'TCF20' 'MAPK11' 'PLXNB2' 'DMD' 'SPRY3'
 <br /><br />   

</Typography>

</div>
)
}